import { useMemo } from "react";
import apiClient from "src/api/axiosClient";
import { CreateKeywordRequestData, GetKeywordsParams, Keyword, UpdateKeywordRequestData } from "../types";

export function useKeywordsApi() {
  return useMemo(
    () => ({
      getKeywords: (params: GetKeywordsParams) => {
        return apiClient.get<{ items: Keyword[]; count: number }>(`/keywords`, { params });
      },

      createKeyword: (companyId: string, data: CreateKeywordRequestData) => {
        return apiClient.post<Keyword>(`/keywords`, data, { params: { companyId } });
      },

      updateKeyword: (companyId: string, keywordId: string, data: UpdateKeywordRequestData) => {
        return apiClient.put<void>(`/keywords/${keywordId}`, data, { params: { companyId } });
      },

      deleteKeyword: (companyId: string, keywordId: string) => {
        return apiClient.delete<void>(`/keywords/${keywordId}`, { params: { companyId } });
      },
    }),
    []
  );
}
